import React from 'react';
import { Input, InputWithSymbol, Multiselect } from '@cokitchen/cokitchen-components';
import { PartnerFormType } from './types';
import { DeleteIcon } from 'cokitchen-icons';
import { AddManagerFormType } from 'components/logistics/add-managers';

export type ManagerFieldType =
  | 'first_name'
  | 'email'
  | 'phone_number'
  | 'user_gender'
  | 'last_name';

const PartnerThirdStep = ({
  handleAddManagers,
  handleDelete,
  formData
}: {
  handleAddManagers: (e: any, i: any, field: ManagerFieldType) => void;
  handleDelete?: (i: number) => void;
  formData: PartnerFormType | AddManagerFormType;
}) => {
  const genderOptions = [
    {
      value: 'Male',
      text: 'Male'
    },
    {
      value: 'Female',
      text: 'Female'
    }
  ];

  const { logistics_admins } = formData;
  return (
    <div className='space-y-8'>
      {logistics_admins.map(({ first_name, last_name, email, phone_number, user_gender }, i) => (
        <div key={i} className='space-y-2 pb-4 relative'>
          <Input
            name='first_name'
            label='First Name'
            placeholder='Jeffery'
            small
            onChange={(e) => handleAddManagers(e, i, 'first_name')}
            value={first_name}
          />

          <Input
            name='last_name'
            label='Last Name'
            placeholder='Boateng'
            small
            onChange={(e) => handleAddManagers(e, i, 'last_name')}
            value={last_name}
          />

          <Input
            name='email'
            label='Email'
            placeholder="Rider's email"
            small
            onChange={(e) => handleAddManagers(e, i, 'email')}
            value={email}
          />
          <div>
            <InputWithSymbol
              type='phone'
              name='phone_number'
              label='Mobile no.'
              placeholder='+234 0124 422 333'
              small
              onChange={(e) => handleAddManagers(e, i, 'phone_number')}
              value={phone_number}
              symbol='flag'
            />
          </div>
          <div
            className={` ${
              i !== logistics_admins.length - 1 && 'border-b border-b-gray-border pb-8'
            }`}>
            <label className='font-medium'>Gender</label>
            <Multiselect
              placeholder='Select Gender'
              isSingle
              values={[user_gender]}
              options={genderOptions}
              onChange={(e) => {
                handleAddManagers(e[0], i, 'user_gender');
              }}
            />
          </div>
          {logistics_admins.length > 1 && (
            <DeleteIcon
              className='bg-red-1 text-red-5 p-[5px] w-6 h-6 rounded-md hover:bg-red-2 transition-all cursor-pointer absolute -top-3 right-0'
              onClick={() => handleDelete?.(i)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default PartnerThirdStep;
